import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';
import './css/index.scss';

import {
  FIREBASE_PERSISTENCE_LOCAL,
  FirebaseAuthProvider,
} from '@smart-maps/firebase';
import firebase from 'firebase/app';
import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import Application from './components/application';
import { GameProvider } from './context';
import { getInitialState } from './redux/initial-state';
import { configure } from './redux/store';
import { ConfigType } from './types';

const { PUBLIC_URL } = process.env;
const initialState = getInitialState();
const { persistor, store } = configure(initialState);

function SmartMaps({ config, version }) {
  // eslint-disable-next-line
  console.log(`Smart Maps v${version}`);
  return (
    // eslint-disable-next-line
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <FirebaseAuthProvider
            firebase={firebase}
            persistence={FIREBASE_PERSISTENCE_LOCAL}>
            <HashRouter basename={PUBLIC_URL}>
              <GameProvider config={config}>
                <Application />
              </GameProvider>
            </HashRouter>
          </FirebaseAuthProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}

SmartMaps.propTypes = {
  config: ConfigType.isRequired,
  version: PropTypes.string.isRequired,
};

SmartMaps.displayName = 'SmartMaps';

export default SmartMaps;
